import Popup from '@/kenwood/configurator/components/Popup';
import { goToPage } from '@/utils/Common/Redirects';
import { pushWannabeHelpMeChoose } from '@/utils/Controllers/GTM/Operations/Kenwood/Configurator';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const BannerContent = ({ onClose, t }) => {
  const onClickHandler = e => {
    e.preventDefault();
    pushWannabeHelpMeChoose();
    goToPage(e.currentTarget.href);
  };
  return (
    <div className='ken-configurator__hmc-banner'>
      {!_isEmpty(
        t('configurator:configurator.hmc.banner.backgound.image.mobile'),
      ) && (
        <img
          className='ken-configurator__hmc-banner-background-image -hidden-m'
          src={t('configurator:configurator.hmc.banner.backgound.image.mobile')}
          alt='HMC-banner-mobile'
        />
      )}
      {!_isEmpty(t('configurator:configurator.hmc.banner.backgound.image')) && (
        <img
          className='ken-configurator__hmc-banner-background-image'
          src={t('configurator:configurator.hmc.banner.backgound.image')}
          alt='HMC-banner'
        />
      )}
      <button
        className='ken-configurator__hmc-banner-close -hidden-m'
        type='button'
        onClick={onClose}
      >
        <img
          className='ken-configurator__hmc-banner-close-img'
          src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/close.svg`}
          alt={t('configurator:configurator.alt.close')}
        />
      </button>
      <div className='ken-configurator__hmc-banner-content'>
        <div className='ken-configurator__hmc-banner-title'>
          <span>{t('configurator:configurator.hmc.banner.title')}</span>
        </div>
        <div className='ken-configurator__hmc-banner-desc'>
          <span>{t('configurator:configurator.hmc.banner.description')}</span>
        </div>
        <div className='ken-configurator__hmc-banner-cta'>
          <a
            type='button'
            className='ken-button--tertiary'
            href={
              DLG.config.encodedContextPath +
              t('configurator:configurator.hmc.banner.cta.link')
            }
            onClick={onClickHandler}
          >
            {t('configurator:configurator.hmc.banner.cta')}
          </a>
        </div>
      </div>
    </div>
  );
};

const HMCBanner = () => {
  const { t } = useTranslation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return (
    <>
      <div className='-hidden-m'>
        <div className='ken-configurator__hmc-banner-cta-mobile'>
          <button
            type='button'
            className='ken-button--secondary'
            onClick={() => setIsMobileOpen(true)}
          >
            {t('configurator:configurator.hmc.banner.title')}
          </button>
        </div>
        <Popup isOpen={isMobileOpen}>
          <BannerContent
            onClose={() => {
              setIsMobileOpen(false);
            }}
            t={t}
          />
        </Popup>
      </div>
      <div className='-hidden -visible-m'>
        <BannerContent t={t} />
      </div>
    </>
  );
};

BannerContent.propTypes = {
  onClose: PropTypes.func,
  t: PropTypes.func.isRequired,
};

BannerContent.defaultProps = {
  onClose: () => {},
};

export default HMCBanner;
